// To make PageSpeed Insights Happy
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

jQuery(document).ready(function($) {
  var controller = new ScrollMagic.Controller();
  var scenesArray = [];

  if($('.wp-block-group').length) {

    $('.wp-block-group .wp-block-columns').each(function() {
      var columnID = 'col' + (Math.floor(Math.random() * 26) + Date.now());
      $(this).attr('id', columnID);
      // console.log($(this).attr('id'));
      // console.log($('#'+columnID).offset().top);
    });

    $('.wp-block-group .wp-block-columns').each(function() {
      scenesArray.push(new ScrollMagic.Scene({
        triggerElement: '#'+$(this).attr('id')
      })
      .setClassToggle('#'+$(this).attr('id'), 'show')
      .reverse(false)
      // .addIndicators()
      .addTo(controller)
      );
    });
  }

  if($('.wp-block-quote').length) {
    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: '.wp-block-quote'
    })
    .setClassToggle('.wp-block-quote', 'show')
    .reverse(false)
    // .addIndicators()
    .addTo(controller)
    );
  }

  if($('.why-whimzees-header').length) {
    $('.why-whimzees-header').each(function() {
      if(!$(this).attr('id')) {
        var headerID = 'col' + (Math.floor(Math.random() * 26) + Date.now());
        $(this).attr('id', headerID);
      }
    });
    $('.why-whimzees-header').each(function() {
      // console.log('#'+$(this).attr('id'));
      scenesArray.push(new ScrollMagic.Scene({
        triggerElement: '#'+$(this).attr('id')
      })
      .setClassToggle('#'+$(this).attr('id'), 'show')
      .reverse(false)
      // .addIndicators()
      .addTo(controller)
      );
    });
  }

  if($('.why-whimzees-columns').length) {
    $('.why-whimzees-columns .wp-block-column').each(function() {
      if(!$(this).attr('id')) {
        var colID = 'col' + (Math.floor(Math.random() * 26) + Date.now());
        $(this).attr('id', colID);
      }

      $('.why-whimzees-columns .wp-block-column').each(function() {
        // console.log('#'+$(this).attr('id'));
        scenesArray.push(new ScrollMagic.Scene({
          triggerElement: '#'+$(this).attr('id')
        })
        .setClassToggle('#'+$(this).attr('id'), 'show')
        .reverse(false)
        // .addIndicators()
        .addTo(controller)
        );
      });

    });
  }

  if($('.why-whimzees-image').length) {
    scenesArray.push(new ScrollMagic.Scene({
      triggerElement: '.why-whimzees-image'
    })
    .setClassToggle('.why-whimzees-image', 'show')
    .reverse(false)
    // .addIndicators()
    .addTo(controller)
    );
  }

  if(window.location.hash && window.location.hash === '#treatQuiz') {
    $('#whimzeesQuiz').foundation('open');
  }

});
